import { render, staticRenderFns } from "./ActivateV1.vue?vue&type=template&id=0cbde6ac"
import script from "./ActivateV1.vue?vue&type=script&lang=js"
export * from "./ActivateV1.vue?vue&type=script&lang=js"
import style0 from "./ActivateV1.vue?vue&type=style&index=0&id=0cbde6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports